export default {
  title: '¿Por qué regenerar esta imagen?',
  description: 'Ayúdanos a mejorar la IA indicando qué falló.',
  reasons: {
    wrong_style: 'Estilo incorrecto',
    wrong_colors: 'Colores incorrectos',
    wrong_food_item: 'Plato incorrecto',
    low_quality: 'Baja calidad',
    doesnt_match_brand: 'No coincide con mi marca',
    text_issues: 'El texto o las etiquetas son incorrectos',
    other: 'Otro',
  },
  details_label: '¿Algo más? (opcional)',
  details_placeholder: 'Añade más detalles para ayudarnos a entender…',
  cancel: 'Cancelar',
  confirm: 'Regenerar',
};
